import io from 'socket.io-client';

import { actions as aiActions } from '$data/assessmentItems';
import { actions as assignmentActions } from '$data/assignments';
import { selectors as coreSelectors } from '$data/core';

import {
  CONNECT,
  SUBSCRIBE,
  GRADE_EXPORT_START,
  GRADE_EXPORT_DONE,
  GRADE_EXPORT_FAILED,
  ASSIGNMENT_GRADED,
  ASSIGNMENT_SUBMITTED,
} from './socket.events';

let socket;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const updateAssignmentAndAssessmentItemGrades =
  (dispatch) =>
  ({ studentId, assignmentId }) => {
    dispatch(
      assignmentActions.updateAssignmentGrades({ assignmentId, studentId })
    );
    dispatch(aiActions.updateStudentGrades({ studentId }));
  };

const connectWithPolling = ({ url, spaceIds }) =>
  io.connect(url, {
    query: `classRooms=${spaceIds}`,
    withCredentials: true,
    rejectUnauthorized: false,
    upgrade: true,
    transports: ['polling', 'websocket'],
    path: '/socket.io',
  });

export const connect = () => async (dispatch, getState) => {
  const state = getState();

  const url = coreSelectors.getWSUrl(state);
  const spaceIds = coreSelectors.getAllSpaceIds(state);

  socket = connectWithPolling({ url, spaceIds });

  // eslint-disable-next-line no-console
  socket.on(CONNECT, () => console.log('Socket: Connected'));

  // list of event listener
  socket.on(GRADE_EXPORT_START, (payload) =>
    dispatch(aiActions.startExportEvent(payload))
  );
  socket.on(GRADE_EXPORT_DONE, () => dispatch(aiActions.endExportEvent()));
  socket.on(GRADE_EXPORT_FAILED, () => dispatch(aiActions.endExportEvent()));

  socket.on(
    ASSIGNMENT_GRADED,
    updateAssignmentAndAssessmentItemGrades(dispatch)
  );
  socket.on(
    ASSIGNMENT_SUBMITTED,
    updateAssignmentAndAssessmentItemGrades(dispatch)
  );

  // wait a bit for socket to be available
  await wait(500);

  return 'socket initialized';
};

export const subscribeByAccessToken = () => (_, getState) => {
  if (socket) {
    const state = getState();
    const spaceId = coreSelectors.getCurrentSpaceId(state);
    const accessToken = coreSelectors.getAccessToken(state, spaceId);

    socket.emit(SUBSCRIBE, accessToken);
  }
};

export default {
  connect,
  subscribeByAccessToken,
};
